"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _noop = _interopRequireDefault(require("../../utils/noop"));

var CascadeContext = /*#__PURE__*/_react.default.createContext({
  expandItem: _noop.default,
  selectItem: _noop.default
});

var _default = CascadeContext;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/Cascader/CascadeContext.js
// module id = 1675
// module chunks = 6 7 17 18